<template>
  <div>
    <b-row>
      <b-form-group
        id="participation-status"
        :label="$t('participation.status')"
        label-for="input-participation-status"
        label-align="left"
        label-cols-sm="4"
        class="col-lg-4"
        v-if="this.filters.status"
      >
        <b-form-select v-model="criteria.status" :options="statuses"> </b-form-select>
      </b-form-group>
      <b-form-group
        :label="$t('training-add.unit')"
        label-align="left"
        class="col-lg-4"
        label-cols-sm="3"
      >
        <v-select
          v-if="units"
          :options="units"
          :placeholder="$t('common.unit-selector.selectAUnit')"
          v-model="criteria.unit"
          label="name"
          :disabled="units.length < 2"
          :clearable="false"
        >
          <template #no-options="{}">
            {{ $t("common.unit-selector.noOptions") }}
          </template>
        </v-select>
      </b-form-group>

      <b-form-checkbox class="col-3" v-model="criteria.includeSubs">
        {{ $t("participations.includeSubs") }}
      </b-form-checkbox>
    </b-row>
    <b-row>
      <b-input-group id="fieldset-horizontal" class="col-md-5" v-if="this.filters.search">
        <b-input
          id="search-input"
          v-model="criteria.search"
          type="search"
          :placeholder="$t('trainings.searchByDescOrSurname')"
        ></b-input>
      </b-input-group>
      <b-button
        class="ml-auto mr-3 esep-blue-bg"
        variant="primary"
        @click="criteriaChanged"
      >
        {{ $t("trainings.search") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { handleApiError } from "@/services/error.service";
import trainingService from "@/services/training.service";

export default {
  props: {
    filters: {
      type: Object,
      default: function () {
        return {
          status: true,
          date: true,
          search: true,
        };
      },
    },
  },
  computed: {
    statuses() {
      return [
        { value: null, text: this.$t("participationStatusEnums.null") },
        { value: "UNDER_REVIEW", text: this.$t("participationStatusEnums.UNDER_REVIEW") },
        {
          value: "AWAITING_PAYMENT",
          text: this.$t("participationStatusEnums.AWAITING_PAYMENT"),
        },
        { value: "PENDING", text: this.$t("participationStatusEnums.PENDING") },
        { value: "CANCELLED", text: this.$t("participationStatusEnums.CANCELLED") },
        { value: "ACCEPTED", text: this.$t("participationStatusEnums.ACCEPTED") },
        { value: "COMPLETED", text: this.$t("participationStatusEnums.COMPLETED") },
        { value: "REJECTED", text: this.$t("participationStatusEnums.REJECTED") },
        { value: "FAILED", text: this.$t("participationStatusEnums.FAILED") },
      ];
    },
  },
  mounted() {
    if (this.$store.state.latestActivityStatus) {
      this.criteria.status = this.$store.state.latestActivityStatus;
    }

    this.getCriteriaSearch();
    this.getUnits();
  },
  data() {
    return {
      units: null,
      criteria: {
        status: "UNDER_REVIEW",
        periodStartDate: null,
        periodEndDate: null,
        search: null,
        unit: null,
      },
    };
  },
  methods: {
    getUnits() {
      trainingService.getUsersPermissions().then(
        (response) => {
          let trainUnits = response.data.VIEW_UNIT || [];

          if (trainUnits) {
            this.units = trainUnits.filter((unit) => unit.status == "ACTIVE");
          } else {
            this.units = [];
          }
          if (this.units.length <= 1) {
            this.criteria.unit = this.units[0];
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    criteriaChanged() {
      if (this.criteria.unit.id) {
        this.$store.state.globalUnitId = String(this.criteria.unit.id);
        localStorage.setItem("global-selected-unit-id", String(this.criteria.unit.id));
      } else {
        this.$store.state.globalUnitId = null;
        localStorage.clear("global-selected-unit-id");
      }
      if (this.units.length <= 1) {
        this.criteria.unit = this.units[0];
      } else {
        this.criteria.unit.id = parseInt(this.$store.state.globalUnitId);
      }
      this.$store.state.latestActivityStatus = this.criteria.status;
      this.$emit("refresh-list", this.criteria);
    },
    getCriteriaSearch() {
      trainingService.getUserInfo(this.username).then(
        (response) => {
          this.userInfo = response.data;
          if (this.userInfo.roles.length >= 1) {
            this.criteria.search = null;
          } else {
            this.criteria.search = this.$route.query.memberId;
          }
          this.$emit("refresh-list", this.criteria);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
  },
};
</script>
